import Vue from 'vue';
import config from 'client/config';

export default function (store) {
  let state = {
    appVersion: null,
    baseUrl: null,
    dockerUrl: null,
    config: null,
    local: false,
    remoteApp: null,
    title: 'ScoreExpress',
  };

  const actions = {
    "environment.get": function (ctx) {
      return new Promise((resolve, reject) => {
        Vue.http.get(config.root + '/environment').then(result => {
          ctx.commit('environment.set', result.data)
          resolve(result.data)
        }, reject)
      })
    },
    "environment.updateConfig": function(ctx, data) {
      return new Promise((resolve, reject) => {
        Vue.http.patch(config.root + '/localConfigs/' + data.id, data).then(() => {
          store.dispatch('environment.get').then(resolve)
        }, err => reject(err))
      })
    },
    "environment.setTitle": function(ctx, title) {
      ctx.commit('environment.setTitle', title)
      document.title = title + ' - ScoreExpress'
    }
  }

  const mutations = {
    "environment.set": function (state, data) {
      state.local = data.isLocal
      state.appVersion = data.appVersion
      state.baseUrl = data.baseUrl
      state.dockerUrl = data.dockerUrl
      state.publicAPI = data.publicAPI
      state.config = data.config
      state.remoteApp = data.remote + config.root
    },
    "environment.setTitle": function(state, title) {
      state.title = title
    }
  }

  store.registerModule('environment', {
    state: state,
    mutations: mutations,
    actions: actions
  })
}
